<template>
  <div>
    <md-content class="plot-ty">
      <div class="md-layout md-gutter type-title md-alignment-center-center" v-show="!isForest" v-if="$store.state.plot.localization.plotType === $store.state.plotTypeLoc.forestPlot">
        <div class="md-layout-item md-size-50"><span style="float: left">{{ $t("typeInfo.radius") }} = {{ radius }}</span></div>
        <div class="md-layout-item md-size-50"><span style="float: right">{{ $t("typeInfo.area") }} = {{ area }} m²</span></div>
      </div>

      <div v-if="$store.state.plot.localization.plotType === $store.state.plotTypeLoc.forestPlot">
        <div v-if="plotType === $store.state.plot_type.forest.id">
          <forest :slope="$store.state.plot.plot.slope" @tmpInfo="addNw" @typeInfo="saveMeasurement" />
        </div>
        <div v-else-if="plotType === $store.state.plot_type.pastures.id">
          <pastures :radius="radius" @tmpInfo="addNw" @typeInfo="saveMeasurement" @area="setArea" />
        </div>
        <div v-else-if="plotType === $store.state.plot_type.shrubs.id">
          <shrubs :radius="radius" @tmpInfo="addNw" @typeInfo="saveMeasurement" @area="setArea" />
        </div>
        <div v-else-if="plotType === $store.state.plot_type.nonwood.id">
          <non-wood :radius="radius" @typeInfo="saveMeasurement" :nw="nw" @area="setArea" />
        </div>
      </div>
      <div v-else-if="$store.state.plot.localization.plotType === $store.state.plotTypeLoc.eventPlot">
        <div v-if="eventType === $store.state.event_type.fire.id">
          <forest-fire @typeInfo="saveMeasurement"></forest-fire>
        </div>
        <div v-if="eventType === $store.state.event_type.erosion.id">
          <erosion @typeInfo="saveMeasurement"></erosion>
        </div>
        <div v-if="eventType === $store.state.event_type.other.id">
          <other @typeInfo="saveMeasurement"></other>
        </div>
        <div v-if="eventType === $store.state.event_type.illegal_cut.id">
          <illegal-cutting @typeInfo="saveMeasurement"></illegal-cutting>
        </div>
      </div>
    </md-content>

    <buttons-nav :prev="prev" step="4" end />

    <md-dialog :md-active.sync="done" :md-fullscreen="false">
      <md-dialog-title>{{ $t('typeInfo.successMsg') }}</md-dialog-title>
      <md-dialog-actions>
        <md-button class="md-primary" @click="onConfirm">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import ButtonsNav from '@/components/ButtonsNav'
// plotType
import Pastures from '@/components/plotType/Pastures'
import Forest from '@/components/plotType/Forest'
import Shrubs from '@/components/plotType/Shrubs'
import NonWood from '@/components/plotType/NonWood'
// eventType
import ForestFire from '@/components/eventType/ForestFire'
import Erosion from '@/components/eventType/Erosion'
import Other from '@/components/eventType/Other'
import IllegalCutting from '@/components/eventType/IllegalCutting'

import uuidv4 from '@/assets/scripts/uuidGenerator'
import { getDomain } from '@/assets/scripts/domainsManager'

const AREA = 'plot_radius'

export default {
  components: {
    ButtonsNav,
    Shrubs,
    NonWood,
    Pastures,
    Forest,
    ForestFire,
    Erosion,
    Other,
    IllegalCutting
  },
  props: ['measurements', 'tmp'],
  data: () => ({
    plotType: '',
    eventType: '',
    typeInfo: {},
    next: true,
    area: 25,
    radius: 0,
    saveData: false,
    nw: false,
    done: false,
    isForest: false,
    edit: false,
    prev: 'Plot'
  }),
  mounted () {
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true
    // if (this.edit) this.typeInfo = this.$store.state.plot.typeInfo
    if (this.$store.state.plot.localization.plotType === this.$store.state.plotTypeLoc.forestPlot) {
      this.getRadius(this.$store.state.plot.plot.slope, this.area)
      this.plotType = this.$store.state.plot.plot.plot_type
    } else {
      this.eventType = this.$store.state.plot.plot.event_type
    }

    if (this.plotType.length > 0) {
      this.setPlotTitle()
    }
    if (this.eventType.length > 0) {
      this.setEventTitle()
    }
  },
  methods: {
    saveMeasurement: function (data) {
      if (this.edit) { // edit
        let plot = this.$store.getters['plot/plot']
        this.measurements.setItem(this.$store.state.plot.id, plot).then(() => {
          this.done = true
          this.$store.commit('plot/setId', null)
          this.$store.commit('plot/clearState', 'plot')
          this.$store.commit('plot/clearState', 'typeInfo')
        }).catch(err => {
          console.log(err)
        })
      } else { // new
        if (this.nw) {
          this.$store.commit('plot/setNonwood', data)
        } else {
          this.$store.commit('plot/setTypeInfo', data)
        }

        let uuid = uuidv4()
        let plot = this.$store.getters['plot/plot']
        this.measurements.setItem(uuid, plot).then(() => {
          this.$store.commit('plot/clearState', 'plot')
          this.$store.commit('plot/clearState', 'typeInfo')
          this.done = true
        }).catch(err => {
          console.log(err)
        })
      }
    },

    getRadius: function (slope, area) {
      getDomain(AREA).then(data => {
        this.radius = data[slope][area]
      })
    },

    addNw: function (typeInfo) {
      // save the tmp info and show non wood form
      if (!this.edit) this.$store.commit('plot/setTypeInfo', typeInfo)
      this.nw = true
      this.isForest = false
      this.plotType = this.$store.state.plot_type.nonwood.id
    },

    onConfirm: function () {
      this.$router.push({ name: 'Home' })
    },

    setArea: function (area) {
      this.area = area
      this.radius = this.getRadius(this.$store.state.plot.plot.slope, area)
    },

    parseDate: function (date) {
      let split = date.split('-')
      return split[0] + split[1] + split[2]
    },

    setPlotTitle: function () {
      let title = ''
      switch (this.plotType) {
        case this.$store.state.plot_type.forest.id:
          title = this.$i18n.t('plot.plotTypeList.forest')
          break
        case this.$store.state.plot_type.pastures.id:
          title = this.$i18n.t('plot.plotTypeList.pastures')
          break
        case this.$store.state.plot_type.shrubs.id:
          title = this.$i18n.t('plot.plotTypeList.shrubs')
          break
        case this.$store.state.plot_type.nonwood.id:
          title = this.$i18n.t('plot.plotTypeList.nonwood')
          break
      }
      title += ' n°' + this.$store.state.plot.plot.plot_num
      this.$emit('title', title)

      if (this.plotType === this.$store.state.plot_type.forest.id) {
        this.isForest = true
      }
    },

    setEventTitle: function () {
      let title = ''
      switch (this.eventType) {
        case this.$store.state.event_type.fire.id:
          title = this.$i18n.t('plot.eventTypeList.forestFire')
          break
        case this.$store.state.event_type.erosion.id:
          title = this.$i18n.t('plot.eventTypeList.erosion')
          break
        case this.$store.state.event_type.other.id:
          title = this.$i18n.t('plot.eventTypeList.others')
          break
        case this.$store.state.event_type.illegal_cut.id:
          title = this.$i18n.t('plot.eventTypeList.illegalCutting')
          break
      }
      title += ' n°' + this.$store.state.plot.plot.event_num
      this.$emit('title', title)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
